import { api } from "../../../lib/axios";

export const getProcurements = (config?: { signal?: AbortSignal }) =>
  api.get("/procurement", config);
export const createProcurement = (data: any) => api.post("/procurement", data);
export const updateProcurement = (id: string, data: any) =>
  api.put(`/procurement/${id}`, data);
export const deleteProcurement = (id: string) =>
  api.delete(`/procurement/${id}`);
